import { useTranslation } from 'react-i18next'
import type { FocusEventHandler } from 'react'

import { FormSection } from '@percent/domain/giving'

import { MaxAttendeesField } from './MaxAttendeesField'
import { NotificationsEnabledCheckbox } from './NotificationsEnabledCheckbox'

interface AttendeesSectionProps {
  participantSpots?: number
  onParticipantSpotsChange: (value: number | undefined) => void
  onBlur: FocusEventHandler<HTMLInputElement>
  participantSpotsTouched?: boolean
  participantSpotsError?: string
  notificationsEnabled: boolean
  onNotificationsEnabledChange: (value: boolean) => void
}

export function AttendeesSection({
  participantSpots,
  onParticipantSpotsChange,
  onBlur,
  participantSpotsTouched,
  participantSpotsError,
  notificationsEnabled,
  onNotificationsEnabledChange
}: Readonly<AttendeesSectionProps>) {
  const { t } = useTranslation()

  return (
    <FormSection title={t('volunteering.opportunity.form.common.attendeesSection.title')}>
      <MaxAttendeesField
        value={participantSpots}
        onChange={onParticipantSpotsChange}
        onBlur={onBlur}
        touched={participantSpotsTouched}
        error={participantSpotsError}
      />

      <NotificationsEnabledCheckbox value={notificationsEnabled} onChange={onNotificationsEnabledChange} />
    </FormSection>
  )
}
